// extracted by mini-css-extract-plugin
export var black = "_3s-6";
export var brand = "_3s-1";
export var ddefault = "_3s-0";
export var error = "_3s-3";
export var gray = "_3s-2";
export var highContrast = "_3s-8";
export var outline = "_3s-7";
export var success = "_3s-5";
export var warning = "_3s-4";